import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "panel"]

  connect() {
    this.triggerTarget.hidden = false
    this.panelTarget.hidden = true
    this.triggerTarget.setAttribute("aria-expanded", "false")
    this.triggerTarget.setAttribute("aria-label", "Open navigation")
    this.triggerTarget.setAttribute("title", "Open navigation")
  }

  toggle() {
    this.panelTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.panelTarget.hidden = false
    this.triggerTarget.setAttribute("aria-expanded", "true")
    this.triggerTarget.setAttribute("aria-label", "Close navigation")
    this.triggerTarget.setAttribute("title", "Close navigation")
    this.panelTarget.querySelector("a")?.focus()
  }

  close() {
    if (this.panelTarget.hidden) return

    this.panelTarget.hidden = true
    this.triggerTarget.setAttribute("aria-expanded", "false")
    this.triggerTarget.setAttribute("aria-label", "Open navigation")
    this.triggerTarget.setAttribute("title", "Open navigation")
    this.triggerTarget.focus()
  }

  closeOnEscape(event) {
    if (!this.panelTarget.hidden) {
      event.preventDefault()
      this.close()
    }
  }
}
